<template>
    <div class="gubaTab-container" style="min-height: 90vh">
        <div class="item-box">
            <div
                v-for="(item, $index) in tabs[tabIndex].list"
                :key="$index"
                class="tab-item"
                @click="goDetail(item)"
            >
                <div>
                    <div class="user-info-box">
                        <img :src="item.image" alt="" />
                        <p class="tab-title">{{ item.nickName }}</p>
                    </div>
                    <p
                        class="wrap-line"
                        :class="{ 'wrap-line-top': item.isTop === 1 }"
                        v-html="transCode2ImgFn(item.title, 'mobile')"
                    ></p>
                    <div
                        class="preview"
                        v-if="item.medias && item.medias.length"
                    >
                        <img :src="item.medias[0].address" />
                    </div>
                    <div class="tab-label">
                        <span>{{ item.createTime | showtime }}</span>
                        <div class="icon-box">
                            <div @click.stop="supportDetailApi(item, $index)">
                                <span
                                    :style="
                                        item.isSupport === 0
                                            ? ''
                                            : 'color: #E94041'
                                    "
                                    >{{ item.supportCount }}</span
                                >
                                <img
                                    v-if="item.isSupport === 0"
                                    class="awesome-icon"
                                    src="../../../assets/icon-awesome-gray.png"
                                />
                                <img
                                    v-else
                                    class="awesome-icon"
                                    src="../../../assets/icon-awesome.png"
                                />
                            </div>

                            <div @click="goDetail(item)">
                                <span>{{ item.reviewCount }}</span>
                                <img
                                    class="review-icon"
                                    src="../../../assets/icon-view.png"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading
            ref="gubainf"
            @infinite="infiniteHandler"
            direction="bottom"
            :distance="100"
            :forceUseInfiniteWrapper="true"
        >
            <div slot="no-more" class="no-more-list">我也是有底线的</div>
            <div
                v-if="tabs[tabIndex].list.length === 0"
                slot="no-results"
                class="no-results"
            ></div>
            <div v-else slot="no-results"></div>
            <div slot="spinner" class="tab-spinner">正在加载...</div>
        </infinite-loading>
        <img
            :style="{ display: showFooter ? 'flex' : 'none' }"
            class="guba-footer-box"
            src="@/assets/guquan-send-icon.png"
            @click="goSend"
        />
        <Toast v-if="showToast" :text="toastText"></Toast>
    </div>
</template>

<script type="text/ecmascript-6">
import moment from 'moment'
import Toast from '@/components/toast.vue'
import InfiniteLoading from 'vue-infinite-loading'
import { request } from '@/api/request'
import { support, unSupport } from '@/api'
import { mapState } from 'vuex'
import { transformEmoji } from '@/utils/transform'

import { transCode2ImgFn } from '../../../components/rhEmoji/index'

export default {
    components: { InfiniteLoading, Toast },
    data() {
        return {
            showToast: false,
            toastText: '',
            showFooter: true
        }
    },
    computed: {
        ...mapState({
            code: state => state.code,
            symbol: state => state.symbol,
            market: state => state.market,
            tabs: state => state.common.tabs,
            tabIndex: state => state.common.tabIndex,
            userInfo: state => state.userInfo
        })
    },
    filters: {
        showtime(_date) {
            let day = moment(new Date())
            let date = moment(_date)
            if (day.year() === date.year()) {
                return date.format('MM-DD hh:mm')
            } else {
                return date.format('YYYY-MM-DD hh:mm')
            }
        }
    },
    activated() {
        this.$refs.gubainf.stateChanger.reset()
    },
    methods: {
        transCode2ImgFn,
        async infiniteHandler($state) {
            let canload = await this.getListData()
            if (canload) $state.loaded()
            else $state.complete()
        },
        computedTitle(title) {
            return transformEmoji(title)
        },
        isLogin() {
            if (!this.userInfo.token) {
                // this._toast('请登录')
                // setTimeout(() => {
                //     this.$router.push(`/login.html`)
                // }, 3000)
                this.$router.push(`/login.html?redirect=${this.$route.path}`)
                return false
            }
            return true
        },
        async supportDetailApi(item, index) {
            const isLogin = this.isLogin()
            if (!isLogin) return

            const { newsId, isSupport } = item
            const params = {
                token: this.userInfo.token,
                serverId: this.userInfo.serverId,
                newsId: newsId
            }
            let res = isSupport === 0 ? await support(params) : await unSupport(params)
            if (res.code === 1) {
                if (item.isSupport === 0) {
                    this.tabs[this.tabIndex].list[index].isSupport = 1
                    this.tabs[this.tabIndex].list[index].supportCount += 1
                } else {
                    this.tabs[this.tabIndex].list[index].isSupport = 0
                    this.tabs[this.tabIndex].list[index].supportCount -= 1
                }
            }
        },
        async getListData() {
            if (this.tabs[this.tabIndex].pageNo === 0) this.tabs[this.tabIndex].pageNo++
            const params = {
                token: this.userInfo.token,
                appCode: '9fztgw',
                symbol: this.code,
                market: this.market === 'HKIDX' ? 'HKSE' : this.market.toLowerCase(),
                pageNo: this.tabs[this.tabIndex].pageNo,
                pageSize: 20
            }
            let res = await request.get({ url: request.apis.stockBar.list, params })
            const { code, data } = res
            if (code === 1) {
                this.tabs[this.tabIndex].list = this.tabs[this.tabIndex].list.concat(data)
                if (data.length > 0) {
                    this.tabs[this.tabIndex].pageNo += 1
                    return true
                }
            }
            else return false
        },
        _toast(toastText, time = 3000) {
            this.toastText = toastText
            this.showToast = true
            setTimeout(() => {
                this.showToast = false
            }, time)
        },
        goLogin() {
            this.tabs[this.tabIndex].pageNo = 1
            this.tabs[this.tabIndex].list = []
            this.$router.push(`/login.html`)
        },
        goDetail(item) {
            // if(!this.userInfo.token) return
            let newsId = item.newsId
            this.$router.push(`/viewDetail/${this.market}/${this.symbol}/${newsId}.html`)
        },
        goSend() {
            if (this.userInfo.token) {
                this.$router.push(`/send/${this.market}/${this.symbol}/send.html`)
            } else {
                this.tabs[this.tabIndex].pageNo = 1
                this.tabs[this.tabIndex].list = []
                this.$router.push(`/login.html?redirect=/send/${this.market}/${this.symbol}/send.html`)
            }
        },
        loginOut() {
            const userInfo = {
                token: '',
                headImage: '',
                serverId: '',
                nickname: '',
                username: ''
            }
            this.tabs[this.tabIndex].pageNo = 1
            this.tabs[this.tabIndex].list = []
            this.$refs.gubainf.stateChanger.reset()
            this.$store.commit('setUserInfo', userInfo)
        },
        handleScroll() {
            if (!document.getElementById('tabs')) return
            let h = document.documentElement.clientHeight
            let btm = document.getElementById('tabs').getBoundingClientRect().bottom
            this.showFooter = !((h - btm) <= 130)
        }
    },
    mounted() {
        this.handerBindthis = this.handleScroll.bind(this)
        window.addEventListener('scroll', this.handerBindthis)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handerBindthis)
    }
}
</script>
<style lang="stylus" scoped>
.gubaTab-container
    display flex
    flex-flow column
    background #f5f5f5

    .no-results
        background url('../../../assets/no_data.png')
        height 200px
        width 200px
        background-size cover
        margin 50px auto

    .no-more-list
        height 60px
        line-height 60px
        background #F5F5F5
        font-size 14px
        font-weight 400
        color #999999
        position relative

        &:before
            content ' '
            height 0
            width 26px
            border none
            border-top 1px solid #DCDCDC
            position absolute
            left 103px
            top 30px

        &:after
            content ' '
            height 0
            width 26px
            border none
            border-top 1px solid #DCDCDC
            position absolute
            right 104px
            top 30px

    .tab-spinner
        font-size 13px
        padding 15px 0 30px 0
        color #999

    .tab-item
        padding 0 12px
        background #fff

        &:last-child
            border-bottom none

        >div
            padding 12px 0
            border-bottom 1px solid #f5f5f5

        .tab-title
            font-size 15px
            color #999999
            line-height 18px
            font-weight 400
            overflow hidden
            text-overflow ellipsis
            display -webkit-box
            -webkit-box-orient vertical
            -webkit-line-clamp 2

        .tab-label
            font-size 12px
            line-height 22px
            color #999
            margin-top 10px
            display flex
            justify-content space-between

    .user-info-box
        display flex
        align-items center
        margin-bottom 4px

        img
            width 30px
            height 30px
            border-radius 50%
            margin-right 8px

        span
            width 0
            flex 1
            overflow hidden
            white-space nowrap
            text-overflow ellipsis

    .wrap-line
        position relative
        word-wrap break-word
        word-break normal
        line-height 22px
        font-size 16px
        color #333333

        &.wrap-line-top
            text-indent 45px
            position relative

        &.wrap-line-top:after
            content ''
            width 40px
            height 18px
            background-image url('../../../assets/top-icon.png')
            background-size 100% 100%
            background-repeat no-repeat
            position absolute
            left 0
            top 2px

    .icon-box
        display flex
        justify-content flex-start
        align-items center
        font-size 14px
        line-height 20px

        >div
            width 45px
            display flex
            justify-content flex-end
            align-items center

        >div:first-child
            margin-right 5px

        .awesome-icon
            width 15px
            height 14px
            margin-left 4px
            margin-top -2px

        .review-icon
            width 15px
            height 14px
            margin-left 4px
            margin-top 1px

    .guba-footer-box
        height 44px
        width 44px
        position fixed
        right 12px
        bottom 85px
        z-index 99

    .footer-box
        display flex
        justify-content space-between
        padding 0 12px

    .preview
        width 92px
        height 92px
        margin 10px 0

    img
        width 100%
        height 100%
        object-fit cover
</style>